import { render, staticRenderFns } from "./EvaluacionDesempenioTabContent.vue?vue&type=template&id=7c882350"
import script from "./EvaluacionDesempenioTabContent.vue?vue&type=script&lang=js"
export * from "./EvaluacionDesempenioTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports